import clsx from 'clsx';
import { Icon as LucideIcon } from 'lucide-react';
import { Icon } from '../Icon/Icon';
import { jsx as _jsx } from "react/jsx-runtime";
const iconNode = [['path', {
  d: 'M12.909 19.924a11.83 11.83 0 0 1-7.597-7.695 12 12 0 0 1 1.78-10.738',
  key: 'gu20rh'
}], ['path', {
  d: 'M15.167 18.994a9.3 9.3 0 0 1-1.779.777c-5.035 1.63-10.435-1.172-12.05-6.268C-.278 8.408 2.51 2.981 7.546 1.35 12.58-.28 17.98 2.522 19.596 7.618a9.76 9.76 0 0 1-.681 7.528',
  key: '1ybvdq'
}], ['path', {
  d: 'M16.088 14.255A11.8 11.8 0 0 0 8.025 1.197',
  key: '100wtf'
}], ['path', {
  d: 'M2.962 16.635A11.45 11.45 0 0 1 9.666 8.59a11.74 11.74 0 0 1 10.562.654',
  key: 'erc61f'
}], ['path', {
  d: 'M22.46 19.185c-.428.216-1.842.458-1.842.458a2.12 2.12 0 0 0-1.4 1.147s-.543 1.554-.921 1.936c-.594.612-2.07.586-2.347-.815l-1.237-5.758a1.462 1.462 0 0 1 1.968-1.669l5.401 2.23c1.287.483 1.312 2 .379 2.47',
  key: 'l5aeka'
}], ['path', {
  d: 'm7.546 1.35 5.842 18.433',
  key: '4e0dme'
}]];
export function ProductDomain({
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Icon, {
    icon: LucideIcon,
    iconNode: iconNode,
    className: clsx('lucide-custom-product-domain', className),
    ...extraProps
  });
}